import { ModalHeader } from 'reactstrap';
import styled from 'styled-components';

const StyledModalHeader = styled(ModalHeader)`
  padding: 24px 24px 0px 24px;
  h5 {
    font-weight: 700;
  }
`;

export default StyledModalHeader;
